import { fetchSafe } from './fetch.safe';
import { responseType } from '../constants';


export const colorService = {
    save,
    deleteColor,
    getEvalDm
}

function save(bwicReferenceName, positionId, color) {
    const url = '/api/color';
    const requestOptions = {
        method: 'POST',
        responseType: responseType.none,
        body: JSON.stringify({
            bwicReferenceName,
            positionId,
            ...color
        })
    };

    return fetchSafe(url, requestOptions);
}

function getEvalDm(ticker, date, px, signal) {
    const url = '/api/color/dm';
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({ ticker, date, px })
    };

    return fetchSafe(url, requestOptions, false, signal);
}

function deleteColor(bwicReferenceName, positionId) {
    const url = `/api/color/${bwicReferenceName}/${positionId}`;
    const requestOptions = {
        method: 'DELETE',
        responseType: responseType.none
    };

    return fetchSafe(url, requestOptions);
}
